import Card from "../../../shared/Card";
import EditableText from "../../../shared/EditableText";
import { parseFixed, renderAmount } from "../../../utils";

const ManifestTotals = ({ info, handleManifestUpdate, ...props }) => {
  return (
    <>
      <Card className="row-span-2 px-10 py-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 lg:grid-cols-4 xl:grid-cols-7">
          <div className="flex flex-col">
            <span className="text-gray-500 mb-1 font-semibold">
              Total Drops
            </span>
            <span className="font-semibold text-lg">
              <p
                type="number"
                id="drops"
                displayText={(e) => (
                  <span className="font-semibold text-lg">{e}</span>
                )}
                value={info.legs.length}
                // onSave={handleManifestUpdate}
              >
                {info.legs.length}
              </p>
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-gray-500 mb-1 font-semibold">
              Total Miles
            </span>
            <span className="font-semibold text-lg">
              <p>
                {parseFixed(info.totalMileage || 0).toLocaleString("en-US")}{" "}
                miles
              </p>
            </span>
          </div>

          {/*           
          <div className="flex flex-col">
            <span className="text-gray-500 mb-1 font-semibold">Total</span>
            <span className="font-semibold text-lg">
              <p
                type="text"
                id="total"
                displayText={(e) => (
                  <span className="font-semibold text-lg">{e}</span>
                )}
                value={info.total}
                onSave={handlePayoutUpdate}
              >
                {renderAmount(Number(info.total))}
              </p>
            </span>
          </div> */}
          <div className="flex flex-col">
            <span className="text-gray-500 mb-1 font-semibold">
              Total Hours
            </span>
            <span className="font-semibold text-lg">
              <p
                type="number"
                id="hours"
                displayText={(e) => (
                  <span className="font-semibold text-lg">{e}</span>
                )}
                value={info.hours}
                // onSave={handlePayoutUpdate}
              >
                {info.hours}
              </p>
            </span>
          </div>
          {/* <div className="flex flex-col">
            <span className="text-gray-500 mb-1 font-semibold">
              Hourly Rate
            </span>
            <span className="font-semibold text-lg">
              <p
                type="number"
                id="hourlyRate"
                displayText={(e) => (
                  <span className="font-semibold text-lg">{e}</span>
                )}
                value={info.rate}
                onSave={handlePayoutUpdate}
              >
                {info.rate}
              </p>
            </span>
          </div> */}
          {/* <div className="flex flex-col">
            <span className="text-gray-500 mb-1 font-semibold">
              Hourly Total
            </span>
            <span className="font-semibold text-lg">
              <p
                type="number"
                id="hourlyTotal"
                displayText={(e) => (
                  <span className="font-semibold text-lg">{e}</span>
                )}
                value={info.hourlyTotal}
                onSave={handlePayoutUpdate}
              >
                {renderAmount(info.hourlyTotal)}
              </p>
            </span>
          </div> */}

          {/* <div className="flex flex-col">
            <span className="text-gray-500 mb-1 font-semibold">
              Mileage Rate
            </span>
            <span className="font-semibold text-lg">
              <p
                type="number"
                id="mileageRate"
                displayText={(e) => (
                  <span className="font-semibold text-lg">{e}</span>
                )}
                value={info.mileageRate}
                onSave={handlePayoutUpdate}
              >
                {info.mileageRate}
              </p>
            </span>
          </div> */}
        </div>
      </Card>

      {/* <Modal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        title="Table Preferences"
        footer={modalFooter}
        content={modalContent}
        size="md"
        footerPosition="right"
      /> */}
    </>
  );
};

export default ManifestTotals;
